<template>
  <a-modal
    title="编辑json"
    :width="1250"
    :visible="visible"
    ok-text="确定"
    cancel-text="取消"
    @ok="onSubumit"
    @cancel="
      () => {
        $emit('cancel');
      }
    "
  >
    <!-- <a-spin> -->
    <a-button type="primary" @click="format"> 格式化json </a-button>
    <a-upload
      accept=".json"
      :customRequest="customRequest"
      :showUploadList="false"
    >
      <a-button style="margin-left:20px"> <a-icon type="upload" /> 上传json文件 </a-button>
    </a-upload>
    <div style="width: 95%; margin: 30px 0 0 30px">
      <b-code-editor
        v-model="jsonStr"
        :auto-format="true"
        :smart-indent="true"
        theme="dracula"
        :indent-unit="4"
        :line-wrap="false"
        ref="editor"
        height="600px"
      ></b-code-editor>
    </div>
    <!-- </a-spin> -->
  </a-modal>
</template>

<script>
export default {
  name: "jsonEditor",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    jsonData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      jsonStr: this.jsonData,
      isok: true
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 90) {
        if (this.jsonStr == "") {
          this.jsonStr = this.jsonData;
        }
      }
    });
  },
  methods: {
    customRequest(file) {
      const that = this
      let file1 = file.file;
          let fileReader = new FileReader();
          fileReader.readAsText(file1, 'UTF-8');
          //fileReader读取是异步操作，操作完之后执行的方法
          fileReader.onloadend = function (e){
            var fileString = e.target.result; // 读取文件内容
            that.$emit('upload', fileString)
          }
    },
    isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      } else if (typeof str == "object" && str) {
        return true;
      }
    },
    onSubumit() {
      const that = this;
      console.log(that.isok);
      var isok = true
    //   if (/^[\],:{}\s]*$/.test(this.jsonData.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))){
    //     // that.$message.error("key值与原值不匹配");
    //  }
    //  else{
    //   that.$message.error("json格式不正确");
    //  }
    //   const jsonValues = JSON.parse(this.jsonData);
    //       const jsonString = JSON.parse(this.jsonStr);
    //       for (var k in jsonValues) {
    //         if (!jsonString.hasOwnProperty(k)) {
    //           // that.$message.error("请勿修改key值,请按ctrl+z返回原属性");
    //           isok = false
    //         }
    //       }
    //   if (!isok) {
    //     that.$message.error("key值与原值不匹配");
    //   } else {
        if (!this.isJSON(this.jsonStr)) {
          this.$message.error(`json格式错误`);
          return false;
        }
        this.$message.success("json格式正确,编辑成功");
        this.$emit('uploadJson', JSON.parse(this.jsonStr))
      // }
      // if (!this.isJSON(this.jsonStr)) {
      //   this.$message.error(`json格式错误`);
      //   return false;
      // }
      // this.$message.success("json格式正确");
      // console.log(JSON.parse(this.jsonStr));
    },
    changeValue(value) {
      const that = this;
      this.jsonStr = value
      if (value == "") {
        return;
      } else {
        try {
          const jsonValues = JSON.parse(this.jsonData);
          const objJson = JSON.parse(value);
          for (var k in jsonValues) {
            if (!objJson.hasOwnProperty(k)) {
              that.$message.error("请勿修改key值,请按ctrl+z返回原属性");
              // that.isok = false
            }
          }
        } catch (res) {
          return false
        }
      }
    },
    format() {
      this.$refs.editor.formatCode();
    },
    upload() {
      this.$emit('upload')
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", (e) => {
      if (e.keyCode == 90) {
        if (this.jsonStr == "") {
          this.jsonStr = this.jsonData;
        }
      }
    });
  },
  watch: {
    jsonData(nev, oldv) {
      this.jsonStr = nev;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .CodeMirror {
  height: 600px !important;
}
</style>